import { render } from "./SideBarNavigation.vue?vue&type=template&id=1818f4b4&scoped=true"
import script from "./SideBarNavigation.vue?vue&type=script&lang=js"
export * from "./SideBarNavigation.vue?vue&type=script&lang=js"

import "./SideBarNavigation.vue?vue&type=style&index=0&id=1818f4b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1818f4b4"]])

export default __exports__